import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Users'*/ 'src/controllers/Users/Users'),
	loading: Loading,
});
